export default "__VITE_ASSET__BaP6Rlxn__"